/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setModal.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(access)/g;

/**
 * モーダル
 */
const setModal = () => {
  if (getPathName.match(pageName)) {
    let body = document.body;
    let modalBox = document.getElementById("modal");
    let modalCloseBtn = document.querySelectorAll(".close-button");
    let modalCloseArea = document.querySelectorAll(".close-area");
    let modalToolNavNext = document.querySelectorAll(".modalToolNavNext");
    let modalToolNavPrev = document.querySelectorAll(".modalToolNavPrev");
    let modalTriggers = document.querySelectorAll(".js-modal-trigger");
    let modalHoverTriggers = document.querySelectorAll(".js-modal-trigger-hover");

    /**
     * 
     * 処理
     * 
     *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

    //オープン
    const openModal = (e) => {
      e.classList.add("is-active");
      e.parentNode.parentNode.classList.add("is-active");
      modalBox.classList.add("is-active");
      body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
    }

    //クローズ
    const closeModal = () => {
      let currentModal = document.querySelectorAll(".js-modal-target.is-active");
      currentModal[0].classList.remove("is-active");
      currentModal[0].parentNode.parentNode.classList.remove("is-active");
      modalBox.classList.remove("is-active");
      body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }

    //ページ送り
    const modalNav = (e) => {
      let currentModal = document.querySelectorAll(".js-modal-target.is-active");
      currentModal[0].classList.remove("is-active");

      if (e === "next") {
        if (currentModal[0].nextElementSibling === null) {
          currentModal[0].parentNode.firstElementChild.classList.add("is-active");
        } else {
          currentModal[0].nextElementSibling.classList.add("is-active");
        }
      }

      if (e === "prev") {
        if (currentModal[0].previousElementSibling === null) {
          currentModal[0].parentNode.lastElementChild.classList.add("is-active");
        } else {
          currentModal[0].previousElementSibling.classList.add("is-active");
        }
      }
    }

    /**
     * 
     * 実行
     * 
     *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

    //オープン - 対象クリック
    for (let i = 0; i < modalTriggers.length; i++) {
      modalTriggers[i].addEventListener("click", (e) => {
        let currentTarget = e.currentTarget;
        let currentModal = document.getElementById(currentTarget.dataset.modal);
        if (currentModal !== null) {
          openModal(currentModal);
        }
      });
    }

    //クローズ - 閉じるボタン
    for (let i = 0; i < modalCloseBtn.length; i++) {
      modalCloseBtn[i].addEventListener("click", closeModal);
    }

    //クローズ - 閉じるエリア
    modalCloseArea[0].addEventListener("click", closeModal);

    //クローズ - ESCキー入力
    window.onkeydown = function (event) {
      modalBox.classList.contains("is-active") ? event.keyCode == 27 && closeModal() : null;
    };

    //ページ送り - 次へ
    modalToolNavNext.forEach(function (next) {
      next.addEventListener("click", (e) => {
        modalNav(e = 'next');
      });
    });

    //ページ送り - 前へ
    modalToolNavPrev.forEach(function (prev) {
      prev.addEventListener("click", (e) => {
        modalNav(e = 'prev');
      });
    });

    //オープン - ホバー
    modalHoverTriggers.forEach(function (elem) {
      elem.addEventListener("mouseover", (e) => {
          let currentTarget = e.currentTarget;
          let currentModal = document.getElementById(currentTarget.dataset.modal);
          if (currentModal !== null) {
            setTimeout(() => {
              openModal(currentModal);
            }, 250);
          }
        },
        false);
    })
  }
};

export {
  setModal
};